import Vue from 'vue';
import Vuetify from 'vuetify';

import nl from 'vuetify/es5/locale/nl';

import '../stylus/main.styl';

Vue.use(Vuetify, {
	lang: {
		locales: { nl },
		current: 'nl'
	},
	theme: {
		primary: '#F18E00',
		secondary: '#17263C',
		accent: '#82B1FF',
		error: '#FF5252',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#FFC107',
	},
});
